import React, {useEffect} from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Caption, H5} from '@modifi/ui'

import {
  useContainerWidth,
  useIsFirstCard,
  useIsLastCard,
  useNotifyUpdatedCards,
} from '../../common-components/default-carousel'
import {BasicCardContent, StyledImg} from './styles'

const getNumberOfCardWidthByContainerWidth = (containerWidth: number): number => {
  let numberOfCards = 1
  if (containerWidth >= 1300) {
    numberOfCards = 3
  }
  if (containerWidth >= 1000) {
    numberOfCards = 2
  }

  return numberOfCards
}

const propTypes = {
  imageUrl: PropTypes.string.isRequired,
  headline: PropTypes.string,
  description: PropTypes.string,
  imageRatio: PropTypes.string,
}

const defaultProps = {
  headline: undefined as null | undefined,
  description: undefined as null | undefined,
  imageRatio: '11',
}

export type BasicCardProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const BasicCard = React.forwardRef<HTMLDivElement, BasicCardProps>(
  ({imageUrl, headline, description, imageRatio}, ref) => {
    const containerWidth = useContainerWidth()
    const desiredNumberOfCards = getNumberOfCardWidthByContainerWidth(containerWidth)
    const isFirstCard = useIsFirstCard()
    const isLastCard = useIsLastCard()
    const notifyUpdatedCards = useNotifyUpdatedCards()

    useEffect(() => {
      // since our BasicCardContent width is depending on the containerWidth we need
      // to trigger a notification
      notifyUpdatedCards()
    }, [containerWidth, notifyUpdatedCards])

    return (
      <BasicCardContent
        ref={ref}
        isActive={isFirstCard}
        containerWidth={containerWidth}
        numberOfCards={desiredNumberOfCards}
        isLastCard={isLastCard}
        isFirstCard={isFirstCard}
      >
        <StyledImg alt={headline || 'modifi-image'} src={imageUrl} imageRatio={imageRatio} />
        {headline && <H5>{headline}</H5>}
        {description && <Caption>{description}</Caption>}
      </BasicCardContent>
    )
  }
)

BasicCard.propTypes = propTypes

BasicCard.defaultProps = defaultProps

export default React.memo(BasicCard)
